import vars from './variables';

export default vars;
